import { useParams, useLocation } from 'react-router';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import { uf_getDate } from '../modules/utils.mjs'

import '../index.css';

import GwCommands from './components/GwCommands'
import LogFileTable from './components/LogFileTable'
import DeviceTable from './components/DeviceTable'
import BrokerTable from './components/BrokerTable'
import SipTable from './components/SipTable'
import DestinationList from './components/DestinationList'
import CallTable from './components/CallTable'
import ConfigTable from './components/ConfigTable'
import BtTableList from './components/BtTableList'
import ZbTableList from './components/ZbTableList'
import RoomsTableDB from './components/RoomsTableDB'
import SensorsTableDB from './components/SensorsTableDB'
import CallsTableDB from './components/CallsTableDB'
import MailDestTableDB from './components/MailDestTableDB'
import ErrorsTableDB from './components/ErrorsTableDB'

import SensorWebSocket from './components/WebSocket';

const API_URL = process.env.REACT_APP_API_URL || "/api";

function gf_mqtt(a_serial, a_apimqttreq) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ serial: a_serial })
  };
  fetch(API_URL + a_apimqttreq, requestOptions);
}

function gf_updatetable(a_bodyparams, a_apimqttset, a_cbusestate) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(a_bodyparams)
  };
  fetch(API_URL + a_apimqttset, requestOptions);
  a_cbusestate(uf_getDate())
}

const Device = () => {
  const params = useParams()
  const location = useLocation();
  const navigate = useNavigate();

  const [tablesData, setTablesData] = useState({
    device: null,
  });
  async function wstable(object, payload) {
    setTablesData((prev) => ({
      ...prev,
      [object]: payload,
    }));
}

  async function f_refreshall() {
    gf_mqtt(params.serial, '/devicemqttreq')
    gf_mqtt(params.serial, '/configmqttreq')
    gf_mqtt(params.serial, '/callmqttreq')
    gf_mqtt(params.serial, '/brokermqttreq')
    gf_mqtt(params.serial, '/sipmqttreq')
    gf_mqtt(params.serial, '/destinationmqttreq')
    gf_mqtt(params.serial, '/logmqttreq')
    gf_mqtt(params.serial, '/btmqttreq')
    gf_mqtt(params.serial, '/zbmqttreq')
  }

  return (
    <>

      <SensorWebSocket
        serial={params.serial}
        onMessages={(msg) => msg?.object && wstable(msg.object, msg.payload)}
      />

      <div>
        <h1>Device: {params.serial} Luogo: {location.state.location} - {location.state.house}</h1>
        <a href="/">
          <button>Back</button>
        </a>
        <button onClick={f_refreshall}>aggiorna tutti</button>
        <button onClick={() => navigate(`/device/${params.serial}/be_log`, {
          state: {
            location: location.state.location,
            house: location.state.house
          }
        })}>
          BE Log
        </button>

        <hr className="divider" />

        <GwCommands
          serial={params.serial}
          data={tablesData.rssi}
          mqttReq={gf_mqtt}
        />

        <hr className="divider" />

        <p>Gateway</p>

        {/* LOG */}
        <LogFileTable
          serial={params.serial}
          data={tablesData.log}
          updateTable={gf_updatetable}
          mqttReq={gf_mqtt}
        />

        {/* DEVICE */}
        <DeviceTable
          serial={params.serial}
          data={tablesData.device}
          updateTable={gf_updatetable}
          mqttReq={gf_mqtt}
        />

        {/* CALL */}
        <CallTable
          serial={params.serial}
          data={tablesData.call}
          updateTable={gf_updatetable}
          mqttReq={gf_mqtt}
        />

        {/* BROKER */}
        <BrokerTable
          serial={params.serial}
          data={tablesData.broker}
          updateTable={gf_updatetable}
          mqttReq={gf_mqtt}
        />

        {/* SIP */}
        <SipTable
          serial={params.serial}
          data={tablesData.sip}
          updateTable={gf_updatetable}
          mqttReq={gf_mqtt}
        />

        {/* CALL-DEST LIST */}
        <DestinationList
          serial={params.serial}
          data={tablesData.destination}
          updateTable={gf_updatetable}
          mqttReq={gf_mqtt}
        />

        {/* CONFIG */}
        <ConfigTable
          serial={params.serial}
          data={tablesData.config}
          updateTable={gf_updatetable}
          mqttReq={gf_mqtt}
        />

        {/* BT LIST */}
        <BtTableList
          serial={params.serial}
          data={tablesData.bt}
          mqttReq={gf_mqtt}
        />

        {/* ZB LIST */}
        <ZbTableList
          serial={params.serial}
          data={tablesData.zb}
          mqttReq={gf_mqtt}
        />

        <br />
        <p>Backend</p>

        {/* ROOMS */}
        <RoomsTableDB
          serial={params.serial}
        />

        {/* SENSORS */}
        <SensorsTableDB
          serial={params.serial}
        />

        {/* CALLS!!! */}
        <CallsTableDB
          serial={params.serial}
          data_bt={tablesData.bt}
        />

        {/* MAIL DEST!!! */}
        <MailDestTableDB
          serial={params.serial}
        />

        {/* ERRORS */}
        <ErrorsTableDB
          serial={params.serial}
        />

      </div>
    </>
  );
};

export default Device;
